import { createReducer } from 'reduxsauce';
import { CHAT, CHAT_ID, NOTIFICATIONS  } from 'actions/Base';
import _ from 'lodash/fp';
import  { parseISO, format, differenceInMinutes } from 'date-fns';
import { ConsoleView } from 'react-device-detect';

export const INITIAL_STATE = {
  list: [],
  chatGroups: {},
  // searchedList: [],
  chatBadgeCount: 0,
  chatBadgeCountIds: [],
  isLoading: false,
  page: 0,
  isLastPage: false,
};

export const onGetChatMessages = (state, { payload }) => { 
    const current = _.cloneDeep(_.get(`chatGroups[${CHAT_ID(payload.params)}]`)(state) || {});

    if(payload.params.page === 0) {
      current.chatMessages = payload.res
      current.seen = true
      current.clicked = true

      if(payload.res.length === 0) {
        current.isLastPage = true
      }
      else {
        current.isLastPage = false
      }
      return _.set(`chatGroups[${CHAT_ID(payload.params)}]`, current)(state);
    }
    else {
      const content = Object.values([...(current.chatMessages || []), ...payload.res], {}).reduce((unique, o) => {
        if(!unique.some(obj => obj.chatMessageId === o.chatMessageId)) {
          unique.push(o);
        }
        return unique;
      },[]);

      current.chatMessages = content
      current.seen = true
      current.clicked = true

      if(payload.res.length === 0) {
        current.isLastPage = true
      }
      else {
        current.isLastPage = false
      }

      return _.set(`chatGroups[${CHAT_ID(payload.params)}]`, current)(state);
    }
};

export const onCreateChatGroup = (state, { payload }) => { 
  return {
    ...state,
    chatGroups: { [CHAT_ID(payload)] : payload, ...state.chatGroups }
  }
};

// export const onCreateMultipleChatGroupByReqIdSuccess = (state, { payload }) => { 
//   return {
//     ...state,
//     chatGroups: Object.assign(state.chatGroups, ...payload)
//   }
// };

export const onGetCurrentChatGroupsRequest = (state, {payload}) => ({ ...state, isLoading: true, page: payload.page });

export const onGetCurrentChatGroupsFailure = (state) => ({ ...state, isLoading: false });

export const onGetCurrentChatGroupsSuccess = (state, { payload }) => {
 
  const {list, page, size, isLastPage} = payload;

      console.log('payload', payload)


  // Push and merge to current objects
  let result = {...state.chatGroups};
  list.forEach(object => {
    result[CHAT_ID(object)] = {...state.chatGroups[CHAT_ID(object)], ...object};
  })

  if(isLastPage) {
    state.isLastPage = true
  }
  else {
    state.isLastPage = false
  }

  return _.set(`chatGroups`, result)(state);
  
};

export const onPollRequest = (state) => ({ ...state, isLoading: true });

/* eslint-disable no-param-reassign */
export const onPollFailure = (state) => { 
  state = {
    ...state, 
    isLoading: false 
  };
  return state;
};

export const onPollSuccess = (state, { payload }) => { 

  // let chatGroupIdsArray = [];

  // Check what chat groups that have received messages
  // payload.chatgroupIdsNotSeen.forEach( (item) => {
  //   chatGroupIdsArray.push(item);
  // });

  state = { 
    ...state, 
    chatBadgeCount: payload.chatgroupIdsNotSeen.length, 
    chatBadgeCountIds: payload.chatgroupIdsNotSeen,
    isLoading: false
  };

  return state; 
};

export const onIncrementBadgeCountRequest = (state, params) => { 

  const arrayValue = state.chatBadgeCountIds.find(id => id === params.params);

  if(arrayValue !== params.params) {
    state = {
      ...state, 
      chatBadgeCount: state.chatBadgeCount+=1, 
      chatBadgeCountIds: [...state.chatBadgeCountIds, params.params] };
  }
  else {
    state = {
      ...state, 
    };  
  }

  return state; 
};

export const onDeleteChatGroupParticipants = (state, { payload }) => {

  console.log('RUNNIG onDeleteChatGroupParticipants', payload)

  // Leave chat button
  if (!!payload?.currentUserLeft) {
    const currentChatGroups = _.cloneDeep(_.get(`chatGroups`)(state) || {});

    delete currentChatGroups[`CHAT-${payload.response.data.chatGroupId}`]

    return _.set(`chatGroups`, currentChatGroups)(state);  
  }
  // NOT USED
  else {
    let currentChatGroupParticipants = _.cloneDeep(_.get(`chatGroups[CHAT-${payload.response.data.chatGroupId}].chatGroupParticipants`)(state) || {});

    console.log('currentChatGroupParticipants', currentChatGroupParticipants)

    currentChatGroupParticipants = payload.response.data.chatGroupParticipants

    console.log('currentChatGroupParticipants', currentChatGroupParticipants)

    return _.set(`chatGroups[CHAT-${payload.response.data.chatGroupId}].chatGroupParticipants`, currentChatGroupParticipants)(state);  
  }

};

export const onAddChatGroupParticipants = (state, { payload }) => {
  const { chatGroupParticipants } = payload.data

  const current = _.cloneDeep(_.get(`chatGroups[${CHAT_ID(payload.data)}]`)(state) || {});

  current.chatGroupParticipants = chatGroupParticipants

  return _.set(`chatGroups[${CHAT_ID(payload.data)}]`, current)(state);
};

// export const onCreateSingleChatMessageSuccess = (state, { payload }) => {
  
//   const current = _.cloneDeep(_.get(`chatGroups[${CHAT_ID(payload.chatGroup)}]`)(state) || {});
  
//   const content = Object.values([payload, ...current.chatMessages || []], {}).reduce((unique, o) => {
//           if(!unique.some(obj => obj.chatMessageId === o.chatMessageId)) {
//             unique.push(o);
//           }
//           return unique;
//       },[]);
//   current.latestChatMessage = payload
//   current.seen = false
//   current.clicked = false
//   current.chatMessages = content
//   current.updated = format(parseISO(payload.updated), 'yyyy-MM-dd HH:mm:ss')
//   return _.set(`chatGroups[${CHAT_ID(payload.chatGroup)}]`, current)(state);
// };

export const onCreateSingleChatMessageSuccess = (state, { payload }) => {  

  if(payload.message.student.studentId !== payload.currentUserId) {
    const current = _.cloneDeep(_.get(`chatGroups[${CHAT_ID(payload.message.chatGroup)}]`)(state) || {});
    
    const content = Object.values([payload.message, ...(current.chatMessages || [])], {}).reduce((unique, o) => {
            if(!unique.some(obj => obj.chatMessageId === o.chatMessageId)) {
              unique.push(o);
            }
            return unique;
        },[]);

    current.latestChatMessage = payload.message
    current.seen = false
    current.clicked = false
    current.chatMessages = content
    current.updated = format(parseISO(payload.message.updated), 'yyyy-MM-dd HH:mm:ss')

    // If users that is in usersTyping has send, remove from usersTyping
    if(current.usersTyping) {
      current.usersTyping.splice(current.usersTyping.findIndex(function(obj){
        return obj.studentId === payload.currentUserId;
      }), 1);
    }

    // Check and fix sameUserAsNextMessage boolean for proper rendering of bubble 
    if(state.chatGroups[CHAT_ID(payload.message.chatGroup)].chatMessages.length) {
      const chatMessages = state.chatGroups[CHAT_ID(payload.message.chatGroup)].chatMessages
      const currentChatMessageIndex = chatMessages.findIndex(obj => obj.id === payload.message.chatMessageId)
      const previousMessage = chatMessages[currentChatMessageIndex+1]
      
      if(previousMessage?.student.studentId === payload.message.student.studentId) {
        const newPreviousMessageObject = { ...previousMessage, sameUserAsNextMessage: true }
        const index = current.chatMessages.findIndex(obj => obj.id === previousMessage.chatMessageId)
        current.chatMessages[index] = newPreviousMessageObject    
      }
    }

    return _.set(`chatGroups[${CHAT_ID(payload.message.chatGroup)}]`, current)(state);
  }
  else {
    return state
  }
};

export const onCreateChatMessageSuccess = (state, { payload }) => {

  const current = _.cloneDeep(_.get(`chatGroups[${CHAT_ID(payload.chatGroup)}]`)(state) || {});

  if(state.chatGroups[CHAT_ID(payload.chatGroup)]) {
    if(!state.chatGroups[CHAT_ID(payload.chatGroup)].chatMessages) {
      current.chatMessages = payload
      current.updated = payload.updated
      return _.set(`chatGroups[${CHAT_ID(payload.chatGroup)}]`, current)(state);
    }
    else {
      const content = Object.values([payload, ...current.chatMessages], {}).reduce((unique, o) => {
              if(!unique.some(obj => obj.chatMessageId === o.chatMessageId)) {
                unique.push(o);
              }
              return unique;
          },[]);

      current.chatMessages = content
      current.updated = payload.updated
      current.seen = true
      current.clicked = true

      return _.set(`chatGroups[${CHAT_ID(payload.chatGroup)}]`, current)(state);
    }
  }

};

export const onCreateChatMessageWithImageRequest = (state, { params }) => {

  const chatMessages = _.cloneDeep(_.get(`chatGroups[CHAT-${params.chatGroup.chatGroupId}].chatMessages`)(state) || {});

  // Fix new message
  const latestMessage = chatMessages.find(x=>x!==undefined);
  
  let closeToPreviousMessage = false;
  let sameUserAsPreviousMessage = false;

  const currentDate = format(new Date(), 'yyyy-MM-dd HH:mm:ss');

  if(latestMessage) {
    if(differenceInMinutes(parseISO(latestMessage.created), parseISO(currentDate)) > -5) {
      closeToPreviousMessage = true;
    }

    if(latestMessage.student.studentId === params.student.studentId) {
      sameUserAsPreviousMessage = true;
    }
  }

  const newMessage = {
    chatMessageId: params.chatMessageHash,
    id: params.chatMessageHash,
    sendMessageFailed: false,
    chatMessageHash: params.chatMessageHash,
    closeToPreviousMessage: closeToPreviousMessage,
    sameUserAsPreviousMessage: sameUserAsPreviousMessage,
    sameUserAsNextMessage: false,
    content: params.content,
    created: currentDate,
    updated: currentDate,
    type: "ChatMessageDTO",
    student: params.student,
    attachmentUrl: params.image.uri,
    attachmentUrlIsLoading: true
  }

  chatMessages.unshift(newMessage)

  // Check and fix sameUserAsNextMessage boolean of last message for proper rendering of bubble 
  if(state.chatGroups[`CHAT-${params.chatGroup.chatGroupId}`].chatMessages.length) {
    const currentChatMessageIndex = chatMessages.findIndex(obj => obj.chatMessageHash === params.chatMessageHash)
    const previousMessage = chatMessages[currentChatMessageIndex+1]
    
    if(previousMessage.student.studentId === params.student.studentId) {
      const newPreviousMessageObject = { ...previousMessage, sameUserAsNextMessage: !previousMessage.sameUserAsNextMessage }
      const index = chatMessages.findIndex(obj => obj.chatMessageHash === previousMessage.chatMessageHash)
      chatMessages[index] = newPreviousMessageObject    
    }
  }

  // If resend, delete message
  if(params.resend) {
    removeObjectFromArrayByAttr(chatMessages, 'id', params.originalChatMessageHash);
  }

  return _.set(`chatGroups[CHAT-${params.chatGroup.chatGroupId}].chatMessages`, chatMessages)(state);

};

export const onCreateChatMessageWithImageSuccess = (state, { payload }) => {

  const { data, params } = payload;

  const chatMessages = _.cloneDeep(_.get(`chatGroups[CHAT-${params.chatGroup.chatGroupId}].chatMessages`)(state) || {});

  const messageToShiftIndex = chatMessages.findIndex(obj => obj.chatMessageHash === params.chatMessageHash)
  chatMessages[messageToShiftIndex] = { 
    ...data,
    attachmentUrlIsLoading: false
  }    

  return _.set(`chatGroups[CHAT-${params.chatGroup.chatGroupId}].chatMessages`, chatMessages)(state);

};

export const onUserTypingSuccess = (state, { params }) => {

  if(`${CHAT_ID(params)}` in state.chatGroups) { 
    const current = _.cloneDeep(_.get(`chatGroups[${CHAT_ID(params)}]`)(state) || {});

    if(!("usersTyping" in current)) {
      current["usersTyping"] = [ params.typingStudent ]
      return _.set(`chatGroups[${CHAT_ID(params)}]`, current)(state);
    }
    else {
      if(!current["usersTyping"].some(obj => obj.studentId === params.typingStudent.studentId)) {
        current["usersTyping"] = [ ...current["usersTyping"], params.typingStudent ]
        return _.set(`chatGroups[${CHAT_ID(params)}]`, current)(state);
      }
    }
  }

  return state;
};

export const onUserTypingDeleteRequest = (state, { params }) => {
  const current = _.cloneDeep(_.get(`chatGroups[${CHAT_ID(params)}]`)(state) || {});

  current.usersTyping.splice(current.usersTyping.findIndex(function(obj){
    return obj.studentId === params.typingStudent.studentId;
  }), 1);

  return _.set(`chatGroups[${CHAT_ID(params)}]`, current)(state);
}

export const onResetBadgeCountRequest = (state) => { 
  state = {...state, chatBadgeCount: 0, chatBadgeCountIds: [] };
  return state; 
};
/* eslint-enable no-param-reassign */

export const ACTION_HANDLERS = {
  [CHAT.GET_CURRENT_CHAT_GROUPS_REQUEST]: onGetCurrentChatGroupsRequest,
  [CHAT.GET_CURRENT_CHAT_GROUPS_FAILURE]: onGetCurrentChatGroupsFailure,
  [CHAT.GET_CURRENT_CHAT_GROUPS_SUCCESS]: onGetCurrentChatGroupsSuccess,
  [NOTIFICATIONS.POLL_REQUEST]: onPollRequest,
  [NOTIFICATIONS.POLL_FAILURE]: onPollFailure,
  [NOTIFICATIONS.POLL_SUCCESS]: onPollSuccess,
  [CHAT.COUNT_REQUEST]: onIncrementBadgeCountRequest,
  [CHAT.RESET_REQUEST]: onResetBadgeCountRequest,
  [CHAT.GET_CHAT_MESSAGES_SUCCESS]: onGetChatMessages,
  [CHAT.CREATE_CHAT_GROUP_SUCCESS]: onCreateChatGroup,
  // [CHAT.CREATE_MULTIPLE_CHAT_GROUP_BY_REQID_SUCCESS]: onCreateMultipleChatGroupByReqIdSuccess,
  [CHAT.DELETE_CHAT_GROUP_PARTICIPANTS_SUCCESS]: onDeleteChatGroupParticipants,
  [CHAT.ADD_CHAT_GROUP_PARTICIPANTS_SUCCESS]: onAddChatGroupParticipants,
  [CHAT.CREATE_SINGLE_CHAT_MESSAGE_REQUEST]: onCreateSingleChatMessageSuccess,
  [CHAT.CREATE_CHAT_MESSAGE_SUCCESS]: onCreateChatMessageSuccess,
  [CHAT.CREATE_CHAT_MESSAGE_WITH_IMAGE_REQUEST]: onCreateChatMessageWithImageRequest,
  [CHAT.CREATE_CHAT_MESSAGE_WITH_IMAGE_SUCCESS]: onCreateChatMessageWithImageSuccess,
  [CHAT.USER_TYPING_SUCCESS]: onUserTypingSuccess,
  [CHAT.USER_TYPING_DELETE_REQUEST]: onUserTypingDeleteRequest,
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
